import { render, staticRenderFns } from "./KiymetTakdirininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=template&id=855571f2"
import script from "./KiymetTakdirininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./KiymetTakdirininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports